import { IProjectDashboard } from "@mctypes/global.types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type LinksSortMode = "manual" | "color";
export interface IProjectDashboardReducer {
  editMode: boolean;
  activeLayout?: IProjectDashboard;
  allLayouts?: IProjectDashboard[];
  linksSortMode: LinksSortMode;
}

const savedLinksSortMode = localStorage.getItem("linksSortMode") as LinksSortMode | null;

const initialState: IProjectDashboardReducer = {
  editMode: false,
  activeLayout: null,
  allLayouts: null,
  linksSortMode: savedLinksSortMode || "color",
};

export const projectDashboardSlice = createSlice({
  name: "projectdashboard",
  initialState,
  reducers: {
    resetProjectDashboardRedux: (state) => {
      state.activeLayout = null;
      state.allLayouts = null;
      state.activeLayout = null;
    },
    setProjectDashBoardEditModeInRedux: (state, action: PayloadAction<boolean>) => {
      state.editMode = action.payload;
    },
    setProjectDashboardActiveLayoutInRedux: (state, action: PayloadAction<IProjectDashboard>) => {
      state.activeLayout = action.payload;
    },
    setProjectDashboardAllLayoutsInRedux: (state, action: PayloadAction<IProjectDashboard[]>) => {
      state.allLayouts = action.payload;
    },
    setLinksSortModeInRedux: (state, action: PayloadAction<LinksSortMode>) => {
      state.linksSortMode = action.payload;
      localStorage.setItem("linksSortMode", action.payload);
    },
  },
});

export const {
  resetProjectDashboardRedux,
  setProjectDashBoardEditModeInRedux,
  setProjectDashboardActiveLayoutInRedux,
  setProjectDashboardAllLayoutsInRedux,
  setLinksSortModeInRedux,
} = projectDashboardSlice.actions;
